import { env } from 'utils/envManager/envManager'

import { DAM_VIDEO_PATH } from '../../constants/constants'

export const getVideoSrc = (src: string): URL => {
	const path = `${DAM_VIDEO_PATH}${src.split('/').at(-1)?.split('?')[0].split('.')[0]}_v`

	return new URL(path, env.NEXT_PUBLIC_ADOBE_DAM_DOMAIN)
}
